<template>
  <div>
    <div class="container pt-4 pt-sm-3 pb-3">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <h1 class="h5 mb-3">
            <router-link v-if="newTireReport" :to="{ name: 'trailer', params: { id: newTireReport.tireReportId } }">
              <i class="far fa-lg fa-angle-left mr-2"></i>Tire positions
            </router-link>
          </h1>

          <hr>
          <div class="btn-group btn-group-sm btn-block mb-3">
            <button type="button" :class="`btn ${action === 'change' ? 'btn-secondary' : 'btn-outline-secondary'}`" @click="changeAction('change')">
              Change<i class="far fa-fw fa-exchange red ml-1"></i>
            </button>
            <button type="button" :class="`btn ${action === 'repair' ? 'btn-secondary' : 'btn-outline-secondary'}`" @click="changeAction('repair')">
              Repair<i class="far fa-fw fa-tools yellow ml-1"></i>
            </button>
            <button type="button" :class="`btn ${action === 'status' ? 'btn-secondary' : 'btn-outline-secondary'}`" @click="changeAction('status')">
              Status<i class="far fa-fw fa-eye ml-1"></i>
            </button>
          </div>
          
          <h3 class="float-right" style="margin-top:-8px">
            <span class="badge badge-secondary">{{tirePosition}}</span>
          </h3>

          <p class="text-uppercase mb-3">
            <span v-if="action === 'change'"><i class="fal fa-fw fa-tire mr-1 red"></i>Removed tire</span>
            <span v-if="action === 'repair'"><i class="fal fa-fw fa-tire mr-1 yellow"></i>Repaired tire</span>
            <span v-if="action === 'status'"><i class="fal fa-fw fa-tire mr-1 grey"></i>Checked tire</span>
          </p>
        
          <template v-if="action === 'change' || action === 'repair'">
            <div class="form-row">
              <div class="col-sm-6">
                <div class="form-group mb-3">
                  <label>Serial <small class="grey">- Optional</small></label>
                  <input type="text" class="form-control" v-model="removedTire.serialNumber" />
                </div> 
              </div>
            </div>
            <div class="form-row">
              <div class="col-sm-4 mt-2 mt-sm-0">
                <div class="form-group mb-3">
                  <label>
                    Brand
                    <span class="text-danger">*</span>
                  </label>
                  <select class="form-control" v-model="removedTire.brand">
                    <option disabled>Select tirebrand</option>
                    <option v-for="(value, key) in tireBrands" :value="key" :key="key">{{ value }}</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-5 mt-2 mt-sm-0">
                <div class="form-group mb-3">
                  <label>
                    Model
                    <span class="text-danger">*</span>
                  </label>
                  <input type="text" class="form-control" v-model="removedTire.description" />
                </div>
              </div>
              <div class="col-6 col-sm-3 mt-2 mt-sm-0">
                <div class="form-group mb-3">
                  <label>
                    MM
                    <span class="text-danger">*</span>
                  </label>
                  <input type="number" step="0.1" min="0" class="form-control" v-model="removedTire.treadDepth" />
                </div>
              </div>
            </div>

            <template>
              <div class="form-row">
                <div class="col-sm-6 mt-2 mt-sm-0">
                  <div class="form-group mb-3">
                    <label>
                      Removal reason
                      <span class="text-danger">*</span>
                    </label>
                    <select class="form-control" v-model="removedTire.removalReason">
                      <option disabled>Select removal reason</option>
                      <option v-for="(value, key) in removalReasons" :value="key" :key="key">{{ value }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-6 mt-3 mt-sm-0">
                  <div class="form-group mb-3">
                    <label>
                      Casing disposal
                      <span class="text-danger">*</span>
                    </label>
                    <select class="form-control" v-model="removedTire.casingDisposal">
                      <option disabled>Select casing disposal</option>
                      <option
                        v-for="(value, key) in casingDisposals"
                        :value="key"
                        :key="key"
                      >{{ value }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </template>
            
            <template v-if="action === 'change'">
              <hr>
              <h3 class="float-right" style="margin-top:-8px">
                <span class="badge badge-secondary">{{tirePosition}}</span>
              </h3>
              <p class="text-uppercase mb-3">
                <i class="fal fa-fw fa-tire mr-1 green"></i>Fitted tire
              </p>
              <div class="form-row">
                <div class="col-sm-6">
                  <div class="form-group mb-3">
                    <label>Serial <small class="grey">- Optional</small></label>
                    <input type="text" class="form-control" v-model="fittedTire.serialNumber" />
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-sm-4 mt-2 mt-sm-0">
                  <div class="form-group mb-3">
                    <label>
                      Brand
                      <span class="text-danger">*</span>
                    </label>
                    <select class="form-control" v-model="fittedTire.brand">
                      <option disabled>Select tirebrand</option>
                      <option v-for="(value, key) in tireBrands" :value="key" :key="key">{{ value }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-5">
                  <div class="form-group mb-3">
                    <label>
                      Model
                      <span class="text-danger">*</span>
                    </label>
                    <input type="text" class="form-control" v-model="fittedTire.description" />
                  </div>
                </div>
                <div class="col-6 col-sm-3 mt-2 mt-sm-0">
                  <div class="form-group mb-3">
                    <label>
                      MM
                      <span class="text-danger">*</span>
                    </label>
                    <input type="number" step="0.1" min="0" class="form-control" v-model="fittedTire.treadDepth" />
                  </div>
                </div>
              </div>
            </template>

              <div class="form-group mb-3">
                <div class="form-row">
                  <div class="col-sm-9">
                    <label>
                      Fitting package
                      <span class="text-danger">*</span>
                    </label>
                    <select class="form-control" v-model="fittedTire.fittingPackage">
                      <option></option>
                      <option
                        v-for="(value, key) in fittingPackages"
                        :value="key"
                        :key="key"
                      >{{ value }}</option>
                    </select>
                  </div>
                </div>
              </div>
          </template>

          <template v-if="action === 'status'">
           <div class="form-row">
              <div class="col-sm-6">
                <div class="form-group mb-3">
                  <label>Serial <small class="grey">- Optional</small></label>
                  <input type="text" class="form-control" v-model="checkedTire.serialNumber" />
                </div> 
              </div>
            </div>
            <div class="form-row">
              <div class="col-sm-4 mt-2 mt-sm-0">
                <div class="form-group mb-3">
                  <label>
                    Brand
                    <span class="text-danger">*</span>
                  </label>
                  <select class="form-control" v-model="checkedTire.brand">
                    <option disabled>Select tirebrand</option>
                    <option v-for="(value, key) in tireBrands" :value="key" :key="key">{{ value }}</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-5 mt-2 mt-sm-0">
                <div class="form-group mb-3">
                  <label>
                    Model
                    <span class="text-danger">*</span>
                  </label>
                  <input type="text" class="form-control" v-model="checkedTire.description" />
                </div>
              </div>
              <div class="col-6 col-sm-3 mt-2 mt-sm-0">
                <div class="form-group mb-3">
                  <label>
                    MM
                    <span class="text-danger">*</span>
                  </label>
                  <input type="number" step="0.1" min="0" class="form-control" v-model="checkedTire.treadDepth" />
                </div>
              </div>
            </div>
            <div class="form-group mb-3">
            <div class="form-row">
              <div class="col-sm-9">
                <label>
                  Condition
                  <span class="text-danger">*</span>
                </label>
                <select class="form-control" v-model="checkedTire.condition">
                  <option></option>
                  <option
                    v-for="(value, key) in conditions"
                    :value="key"
                    :key="key"
                  >{{ value }}</option>
                </select>
              </div>
            </div>
          </div>
          </template>

          <button
            @click="save"
            tag="button"
            :disabled="!canSave"
            class="btn btn-info btn-lg btn-block mt-4"
          >Save tire</button>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { TireBrands } from "../../filters/tirebrands";
import { FittingPackages } from "../../filters/fittingpackage";
import { RemovalReasons } from "../../filters/removalreasons";
import { CasingDisposals } from "../../filters/casingdisposal";
import { Conditions } from "../../filters/condition";

export default {
  metaInfo: {
    title: "Tire position"
  },
  data: () => {
    return {
      tireBrands: TireBrands,
      fittingPackages: FittingPackages,
      removalReasons: RemovalReasons,
      casingDisposals: CasingDisposals,
      conditions: Conditions,
      removedTire: {
        serialNumber: null,
        brand: null,
        description: null,
        treadDepth: null,
        removalReason: null,
        casingDisposal: null,
        repaired: false,
      },
      fittedTire: {
        serialNumber: null,
        brand: null,
        description: null,
        treadDepth: null,
        fittingPackage: null,
      },
      checkedTire: {
        serialNumber: null,
        brand: null,
        description: null,
        treadDepth: null,
        condition: null,
      },
    action: "change",
    };
  },
  props: {
    tirePosition: String
  },
  computed: {
    ...mapState("tireReports", ["newTireReport", "lastServicedTires"]),
    canSave: function() {
      switch(this.action) {
        case 'change':
          return this.removedTire &&
          this.removedTire.brand &&
          this.removedTire.description &&
          this.removedTire.treadDepth &&
          this.removedTire.removalReason &&
          this.removedTire.casingDisposal &&
          this.fittedTire &&
          this.fittedTire.fittingPackage &&
          this.fittedTire.brand &&
          this.fittedTire.description &&
          this.fittedTire.treadDepth
          break;
        case 'repair':
          return this.removedTire &&
          this.removedTire.brand &&
          this.removedTire.description &&
          this.removedTire.treadDepth &&
          this.removedTire.removalReason &&
          this.removedTire.casingDisposal &&
          this.fittedTire &&
          this.fittedTire.fittingPackage
          break;
        case 'status':
          return this.checkedTire &&
          this.checkedTire.brand &&
          this.checkedTire.description &&
          this.checkedTire.treadDepth &&
          this.checkedTire.condition
          break;
        default:
          return false
      }
    }
  },
  methods: {
    ...mapActions("tireReports", ["addTireData"]),
    save() {
      this.removedTire.repaired = false // default repaired to false

      // If repair, fitted tire equals removed tire
      if (this.action === 'repair') {
        this.removedTire.repaired = true
        this.fittedTire.serialNumber = this.removedTire.serialNumber
        this.fittedTire.brand = this.removedTire.brand
        this.fittedTire.description = this.removedTire.description
        this.fittedTire.treadDepth = this.removedTire.treadDepth
        this.fittedTire.removalReason = this.removedTire.RemovalReason
        this.fittedTire.casingDisposal = this.removedTire.casingDisposal
      }
      
      // Enforce decimal limit
      this.removedTire.treadDepth = parseFloat(this.removedTire.treadDepth).toFixed(1)
      this.fittedTire.treadDepth = parseFloat(this.fittedTire.treadDepth).toFixed(1)
      this.checkedTire.treadDepth = parseFloat(this.checkedTire.treadDepth).toFixed(1)

      // Only save data from active section
      let tireData = {}
      if (this.action === 'repair' || this.action === 'change') {
        tireData = {
          removedTire: this.removedTire,
          fittedTire: this.fittedTire,
        }
      } else if (this.action === 'status' ){
        tireData = {
          checkedTire: this.checkedTire,
        }
      } else {
        return // We cannot add data without an selected action (status/repair/change)
      }

      this.addTireData({
        tirePosition: this.tirePosition,
        tireData
      });
      this.$router.push({
        name: "trailer",
        params: { id: this.newTireReport.tireReportId }
      });
    },
    changeAction(action){
      if (action) this.action = action
    },
  },
  mounted() {
    // abort if newTireReport has not been created correctly.
    if (!this.newTireReport || !this.newTireReport.tireReportId) {
      if (this.$route.params.id) {
        this.$router.push({
        name: "trailer",
        params: { id: this.$route.params.id }
      });
      } else {
        this.$router.replace({ name: "frontpage" });
      }
      return;
    }
    
    if ( // insert tire data for this tire, if the user has already added some data for it in this session
      this.newTireReport.tires &&
      this.newTireReport.tires[this.tirePosition]
    ) {
      if (this.newTireReport.tires[this.tirePosition].removedTire) this.removedTire = this.newTireReport.tires[this.tirePosition].removedTire;
      if (this.newTireReport.tires[this.tirePosition].fittedTire) this.fittedTire = this.newTireReport.tires[this.tirePosition].fittedTire;
      if (this.newTireReport.tires[this.tirePosition].checkedTire) this.checkedTire = this.newTireReport.tires[this.tirePosition].checkedTire;
    }
    // else insert relevant data from last fitted tire into removed and checked tire fields
    else if(this.lastServicedTires && this.lastServicedTires[this.tirePosition]){
       this.removedTire.serialNumber = this.lastServicedTires[this.tirePosition].serialNumber || null
       this.removedTire.description = this.lastServicedTires[this.tirePosition].description || null
       this.removedTire.brand = this.lastServicedTires[this.tirePosition].brand || null

       this.checkedTire.serialNumber = this.lastServicedTires[this.tirePosition].serialNumber || null
       this.checkedTire.description = this.lastServicedTires[this.tirePosition].description || null
       this.checkedTire.brand = this.lastServicedTires[this.tirePosition].brand || null
    }
  }
};
</script>
